import React from "react";
import { drawingToSvgPrimitive } from "./drawingGeometry";
import "./ChartDrawingOverlay.css";

function ChartDrawingOverlay({
  drawings = [],
  geometry,
  chartWidth,
  priceHeight,
  onSelectDrawing,
  onDrawingPointerDown,
  onDrawingPointerMove,
  onDrawingPointerUp,
}) {
  if (!Array.isArray(drawings) || !geometry) return null;

  return (
    <g className="chartDrawingOverlay" data-testid="chart-drawing-overlay">
      {drawings.map((drawing) => {
        const primitive = drawingToSvgPrimitive(
          drawing,
          geometry,
          chartWidth,
          priceHeight
        );
        if (!primitive || primitive.type !== "line") return null;

        return (
          <line
            key={drawing.id}
            data-testid={`chart-drawing-${drawing.id}`}
            data-drawing-tool={drawing.toolId}
            data-drawing-locked={drawing.isLocked ? "true" : "false"}
            className={`chartDrawingLine${drawing.isSelected ? " selected" : ""}${drawing.isLocked ? " locked" : ""}`}
            x1={primitive.x1}
            y1={primitive.y1}
            x2={primitive.x2}
            y2={primitive.y2}
            role="button"
            tabIndex={0}
            aria-label={`Select ${drawing.isLocked ? "locked " : ""}${drawing.toolId} drawing`}
            onPointerDown={(event) => {
              event.stopPropagation();
              onDrawingPointerDown?.(event, drawing);
            }}
            onPointerMove={(event) => onDrawingPointerMove?.(event, drawing)}
            onPointerUp={(event) => onDrawingPointerUp?.(event, drawing)}
            onPointerCancel={(event) => onDrawingPointerUp?.(event, drawing)}
            onClick={(event) => {
              event.stopPropagation();
              onSelectDrawing?.(drawing.id);
            }}
            onKeyDown={(event) => {
              if (event.key !== "Enter" && event.key !== " ") return;
              event.preventDefault();
              onSelectDrawing?.(drawing.id);
            }}
          />
        );
      })}
    </g>
  );
}

export default ChartDrawingOverlay;
